export default "__VITE_ASSET__DYDccUn2__"